import React from 'react';
import Form from 'pages/app-profiles/landing-zones-new/components/Form';
import { Grid, Stack } from '@mui/material';

const KafkaFields = () => (
    <>
        <Grid item xs={6}>
            <Stack direction="column" spacing={2}>
                <Form.Department />
                <Form.Region />
                <Form.Cluster />
                <Form.ProjectName />
                <Form.LandingZoneLabel />
            </Stack>
        </Grid>
        <Grid item xs={6}>
            <Stack direction="column" spacing={2}>
                <Form.Environments />
                <Form.BusinessUnit />
                <Form.Ldap />
                <Form.ISADocument />
                <Form.LandingZoneDesc />
            </Stack>
        </Grid>
    </>
);

export default KafkaFields;
